// extracted by mini-css-extract-plugin
module.exports = {"categoryContent":"CategoryProfile_categoryContent__hmd-E"};